// extracted by mini-css-extract-plugin
module.exports = {"Seal":"Seal_Seal__ySXMb","Message":"Seal_Message__pv3mi","Container":"Seal_Container__18mCr"};